import $ from 'jquery';

$(function () {
    NS.scrollTriggerDown = false;

    // set correct blue color on dropdowns
    $('form select').on('change', function() {
        if ($(this).val() !== '') {
            $(this).addClass('form__input-selected');
        } else {
            $(this).removeClass('form__input-selected');
        }
    });

    // show or hide menu on scroll
    if ($('.navigation--fixed').length === 0)
    {
        $(window).on('scroll', function () {

            var trigger = $(window).height(),
                where = window.pageYOffset + 92;

            // we're scrolling down
            if (!NS.scrollTriggerDown && where >= trigger) {
                $('html').addClass('sticky--navigation');
                NS.nav.addClass('navigation--fixed navigation--fixed-animation').removeClass('navigation--fixed-up');
                NS.scrollTriggerDown = true;
                NS.scrollTriggerUp = false;
            }

            // we're scrolling up
            if (!NS.scrollTriggerUp && where < trigger) {
                NS.nav.addClass('navigation--fixed-up');
                setTimeout(function () {
                    $('html').removeClass('sticky--navigation');
                    NS.nav.removeClass('navigation--fixed navigation--fixed-up navigation--fixed-animation');
                    $('.navigation__logo-box').removeClass('navigation').removeClass('navigation--fixed');

                }, 300)
                NS.scrollTriggerDown = false;
                NS.scrollTriggerUp = true;
                NS.checkAndCloseMobileMenu();
            }
        });
    }
});
